/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credit_Exhaustion_Upgrade_StudentInputs */

const en_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Student -- EUR 14.99/mo`)
};

const de_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Student upgraden -- EUR 14,99/Monat`)
};

const fr_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Étudiant -- EUR 14,99/mois`)
};

const es_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a Estudiante -- EUR 14,99/mes`)
};

const it_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Studente -- EUR 14,99/mese`)
};

const nl_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade naar Student -- EUR 14,99/maand`)
};

const pl_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź na Student -- EUR 14,99/mies.`)
};

const fi_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä Opiskelija -- EUR 14,99/kk`)
};

const da_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader til Student — EUR 14,99/md`)
};

const sv_credit_exhaustion_upgrade_student = /** @type {(inputs: Credit_Exhaustion_Upgrade_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera till Student -- EUR 14,99/mån`)
};

/**
* | output |
* | --- |
* | "Upgrade to Student -- EUR 14.99/mo" |
*
* @param {Credit_Exhaustion_Upgrade_StudentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_upgrade_student = /** @type {((inputs?: Credit_Exhaustion_Upgrade_StudentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_Upgrade_StudentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_upgrade_student(inputs)
	if (locale === "fr") return fr_credit_exhaustion_upgrade_student(inputs)
	if (locale === "es") return es_credit_exhaustion_upgrade_student(inputs)
	if (locale === "it") return it_credit_exhaustion_upgrade_student(inputs)
	if (locale === "nl") return nl_credit_exhaustion_upgrade_student(inputs)
	if (locale === "pl") return pl_credit_exhaustion_upgrade_student(inputs)
	if (locale === "fi") return fi_credit_exhaustion_upgrade_student(inputs)
	if (locale === "da") return da_credit_exhaustion_upgrade_student(inputs)
	if (locale === "sv") return sv_credit_exhaustion_upgrade_student(inputs)
	return en_credit_exhaustion_upgrade_student(inputs)
});